import PropTypes from "prop-types";
import * as React from "react";
import MembersOperationDialog from "./MembersOperationDialog";
import { translate } from "react-i18next";

const propTypes = {
  membersToRemove: PropTypes.array.isRequired,

  onCloseClick: PropTypes.func.isRequired,
  onRemoveClick: PropTypes.func.isRequired,

  t: PropTypes.func.isRequired
};

const RemoveMembersOperationDialog = props => <MembersOperationDialog buttonActionTitle={props.t('Исключить')} buttonCloseTitle={props.t('Закрыть')} controlElement={null} membersForOperate={props.membersToRemove} spinnerLabel={props.t('Исключаем из клана')} textBeforeMembers={props.t('Исключить игроков из клана:')} title={props.t('Исключение из клана')} onActionClick={props.onRemoveClick} onCloseClick={props.onCloseClick} />;

RemoveMembersOperationDialog.propTypes = propTypes;

export default translate()(RemoveMembersOperationDialog);